@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div class="flex flex-col justify-between h-full">
    <div>
      <div class="pb-md mb-lg">
        <a (click)="goBack()">
          <lib-chevron-down-icon
            [iconClass]="
              'size-10 text-neutral-900 rotate-90 p-sm rounded-lg cursor-pointer border border-neutral-200'
            " />
        </a>
      </div>
      <div class="border-b border-neutral-200 mb-2xl">
        <p class="text-2xl text-neutral-900 font-semibold pb-lg">
          {{ categoryDetails().name }}
        </p>
      </div>
      <div
        class="py-xl flex justify-between items-center border-b border-neutral-200 mb-lg">
        <div class="flex gap-lg items-center">
          <p class="text-neutral-900 font-semibold text-lg">
            {{ 'workflow_permissions_list_screen_sub_title_label' | transloco }}
          </p>

          <lib-badge
            [label]="totalOwnersCount()"
            badgeClass="px-sm border-none text-sm font-medium bg-primary-50 text-primary-600" />
        </div>

        <button
          type="button"
          class="bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm flex items-center"
          (click)="openAssignOwnersDialog()"
          id="workflow_permissions_details_screen_add_owners_label">
          <lib-add-icon [iconClass]="'size-5 text-white'" />

          {{
            'workflow_permissions_details_screen_add_owners_label' | transloco
          }}
        </button>
      </div>
      <div>
        <lib-group-user-card
          [actionList]="actionList"
          [list]="mappedCategoryOwners()"
          itemType="User"
          (actionListItemClickEmitter)="actionListItemClick($event)"
          [mode]="'view'"></lib-group-user-card>
      </div>
    </div>
    @if (categoryOwners().length) {
      <div class="p-sm">
        <lib-paginator
          class="mt-4xl"
          [sizeOptionsLabel]="
            'pagination_number_of_rows_per_page_label' | transloco
          "
          [nextBtnLabel]="'pagination_next_button_label' | transloco"
          [previousBtnLabel]="'pagination_previous_button_label' | transloco"
          [currentPage]="currentPage()"
          [totalPages]="totalPages()"
          [totalItems]="+totalOwnersCount()"
          [showChangeSize]="true"
          (goTo)="handlePagination($event)"
          (next)="handlePagination($event)"
          (previous)="handlePagination($event)"
          [currentSize]="currentSize()"
          [showChangeSize]="false"></lib-paginator>
      </div>
    }
  </div>
}
<ng-template #removeOwner>
  <div class="flex justify-center">
    <div
      class="flex justify-center items-center bg-destructive-50 p-lg rounded-full mb-xl">
      <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm text-neutral-900">
    {{ 'workflow_permissions_details_remove_owner_popup_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'workflow_permissions_details_remove_owner_popup_warning' | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      (click)="onRemoveUser()"
      [class.opacity-30]="isRemoveUserLoading()"
      [disabled]="isRemoveUserLoading()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{
        'workflow_permissions_details_remove_owner_popup_yes_remove_it_button'
          | transloco
      }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{
        'workflow_permissions_details_remove_owner_popup_no_keep_it_button'
          | transloco
      }}
    </button>
  </div>
</ng-template>

<ng-template #assignOwnersDialog>
  <lib-assign-group-users
    [groupUsersCards]="groupUsersCards()"
    [selectedGroupUsersCards]="selectedUsers()"
    (unselectGroupUser)="removeSelectedGroupUser($event)"
    (selectGroupUser)="onSelectGroupUser($event)"
    (filterGroupUsersCards)="getUsers($event)"
    (paginateGroupUsersCards)="getUsers('', $event)"
    (saveAssignedGroupUsers)="onSubmitAssignedGroupUsers()"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="modalCurrentPage()"
    [totalPages]="modalTotalPages()"
    [itemType]="'User'"
    [isSubmitLoading]="isAssignOwnersLoading()"
    (cancelModal)="clearSelectedUsers()" />
</ng-template>
